<template>
    <div class="consume_detail-container">
        <div class="detail-title-wrap">
            <span class="detail-title">加油消费</span>
            <van-tag :color="consumeInfo.oilModel | oilModelFormat" size="large">{{consumeInfo.oilModel}}</van-tag>
            <van-tag :color="consumeInfo.oilName | oilNameFormat" size="large">{{consumeInfo.oilName}}</van-tag>
        </div>
        <order-detail :order-id="orderId" :order-type="1" @pass-data="passData"></order-detail>
    </div>
</template>

<script>
    import OrderDetail from './OrderDetail'
    import mixin from '../mixin'

    export default {
        name: 'ConsumeDetail',
        components: {OrderDetail},
        mixins: [mixin],
        data () {
            return {
                consumeInfo: {},
                orderId: ''
            }
        },
        mounted () {
            this.orderId = this.$route.params.orderId
        },
        methods: {
            // 子组件传递数据给父组件
            passData (data) {
                this.consumeInfo = data
            }
        }
    }
</script>

<style lang="scss" scoped>
    .consume_detail-container {
        .detail-title-wrap {
            padding: 16px 20px 8px;
        
            .detail-title {
                margin-bottom: 10px;
                color: #333333;
                background: #ffffff;
                font-size: 16px;
                font-weight: bold;
                border-bottom: #ebedf0 solid 1px;
                vertical-align: middle;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/ConsumeDetail.vue